import { Modal } from "@/frontend/shared/ui/Modal";
import { Typography } from "@/frontend/shared/ui/Typography";
import { useState } from "react";
import styles from "./InvestorReportAnErrorModal.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { Textarea } from "@/frontend/shared/ui/Textarea/Textarea";
import { ConfirmationModal } from "@/frontend/shared/ui/ConfirmationModal/ConfirmationModal";
import { EErrorType, postReportError } from "../model/services/postReportError";
import { snackbarConstructor } from "@/frontend/shared/ui/CustomNotifications/ui/Snackbar/snackbarConstructor";
import { reportErrorToSentry } from "@/frontend/shared/lib/reportErrorToSentry/reportErrorToSentry";
import { AxiosError } from "axios";
import { CancelButton } from "@/frontend/shared/ui/Button/CancelButton/CancelButton";

export function InvestorReportAnErrorModal({
  isOpen,
  onClose,
  companyId
}: {
  isOpen: boolean;
  onClose: () => void;
  companyId: number;
}) {
  const [errorDescription, setErrorDescription] = useState("");
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);
  const [isReportSending, setIsReportSending] = useState(false);

  function onConfirmDiscardChanges() {
    setIsOpenConfirmationModal(false);
    setErrorDescription("");
    onClose();
  }

  async function onReportError() {
    setIsReportSending(true);
    try {
      await postReportError({ description: errorDescription, type: EErrorType.CONTENT_RELATED, id: companyId });
      snackbarConstructor("Error report sent", "normal");
    } catch (error) {
      snackbarConstructor("Error report failed", "error");
      reportErrorToSentry(error as AxiosError, "report-error");
    } finally {
      setErrorDescription("");
      onClose();
      setIsReportSending(false);
    }
  }

  const content = (
    <div>
      <Textarea
        value={errorDescription}
        onChange={(e) => setErrorDescription(e.target.value)}
        placeholder="Describe an error"
        className={styles.websiteInput}
      />
      {/* <Typography variant="body-3" color="greyscale500" className={styles.description}>
        Please provide a detailed description of the error.
      </Typography> */}
      <div className={styles.bottomButtonContainer}>
        <CancelButton onClick={onCloseModal}>Cancel</CancelButton>
        <NormalButton
          size="large"
          onClick={onReportError}
          isDisabled={!errorDescription || isReportSending}
          className={styles.reportBtn}
        >
          Send
        </NormalButton>
      </div>
    </div>
  );

  function onCloseModal() {
    if (errorDescription !== "") {
      setIsOpenConfirmationModal(true);
    } else {
      onClose();
    }
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onCloseModal} title={"Report an error"} width={"454px"} className={styles.modal}>
        {content}
      </Modal>
      <ConfirmationModal
        isOpen={isOpenConfirmationModal}
        onClose={() => setIsOpenConfirmationModal(false)}
        onConfirm={onConfirmDiscardChanges}
        content={"Are you sure you want to discard the changes you made?"}
        title={"Discard Changes"}
        confirmButtonText={"Discard"}
        cancelButtonText={"No Thanks"}
        dangerConfirm
      />
    </>
  );
}
